var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8151_51156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5859 6.97998C21.5659 6.97998 21.5359 6.97998 21.5059 6.97998C16.2159 6.44998 10.9359 6.24998 5.70585 6.77998L3.66585 6.97998C3.24585 7.01998 2.87585 6.71998 2.83585 6.29998C2.79585 5.87998 3.09585 5.51998 3.50585 5.47998L5.54585 5.27998C10.8659 4.73998 16.2559 4.94998 21.6559 5.47998C22.0659 5.51998 22.3659 5.88998 22.3259 6.29998C22.2959 6.68998 21.9659 6.97998 21.5859 6.97998Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.08595 5.97C9.04595 5.97 9.00595 5.97 8.95595 5.96C8.55595 5.89 8.27595 5.5 8.34595 5.1L8.56595 3.79C8.72595 2.83 8.94595 1.5 11.2759 1.5H13.8959C16.2359 1.5 16.4559 2.88 16.6059 3.8L16.8259 5.1C16.8959 5.51 16.6159 5.9 16.2159 5.96C15.8059 6.03 15.4159 5.75 15.3559 5.35L15.1359 4.05C14.9959 3.18 14.9659 3.01 13.9059 3.01H11.2859C10.2259 3.01 10.2059 3.15 10.0559 4.04L9.82595 5.34C9.76595 5.71 9.44595 5.97 9.08595 5.97Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7958 23.0001H9.37584C5.88584 23.0001 5.74584 21.0701 5.63584 19.5101L4.98584 9.44007C4.95584 9.03007 5.27584 8.67008 5.68584 8.64008C6.10584 8.62008 6.45584 8.93008 6.48584 9.34008L7.13584 19.4101C7.24584 20.9301 7.28584 21.5001 9.37584 21.5001H15.7958C17.8958 21.5001 17.9358 20.9301 18.0358 19.4101L18.6858 9.34008C18.7158 8.93008 19.0758 8.62008 19.4858 8.64008C19.8958 8.67008 20.2158 9.02007 20.1858 9.44007L19.5358 19.5101C19.4258 21.0701 19.2858 23.0001 15.7958 23.0001Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.246 17.5H10.916C10.506 17.5 10.166 17.16 10.166 16.75C10.166 16.34 10.506 16 10.916 16H14.246C14.656 16 14.996 16.34 14.996 16.75C14.996 17.16 14.656 17.5 14.246 17.5Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0859 13.5H10.0859C9.67594 13.5 9.33594 13.16 9.33594 12.75C9.33594 12.34 9.67594 12 10.0859 12H15.0859C15.4959 12 15.8359 12.34 15.8359 12.75C15.8359 13.16 15.4959 13.5 15.0859 13.5Z",
    fill: "black",
    fillOpacity: 0.38
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8151_51156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashGrey);
export default __webpack_public_path__ + "static/media/trashGrey.c80bff7068d1d4328714f477aadacf54.svg";
export { ForwardRef as ReactComponent };